import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectRpServiceId } from "@utils/parameter-injector";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";

export const getVerificationServiceDetailsAxnAdminRequest = async (
    rpServiceId: string,
): Promise<{ data: RpServiceConfiguration, error: any }> => {
    const route = injectRpServiceId(apiRoutes.serviceConfiguration.rpServiceConfig.axnAdmin.rpService, rpServiceId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};
